import classes from "../../css/modules/navigation.module.scss";
import React, { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { routes } from "../../utils/constants";
import { Text } from "../Text";
import { useDispatch, useSelector } from "react-redux";
import { pageTitle, selectors } from "../../redux/pageTitle";

/**
 * @type {{[p: string]: string|false}}
 */
const titles = {
  [routes.projects]: "Projects",
  [routes.templates]: "Templates",
  [routes.templateComponents]: "Template Components",
  [routes.totalProjectOverview]: "Project total overview",
  [routes.project]: false,
  [routes.departmentOverview]: "Department overview",
  [routes.settings]: "Settings",
};

export function PageTitle() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const title = useSelector(selectors.get);

  useEffect(() => {
    const titleKey = Object.keys(titles).find((i) => matchPath(pathname, { path: i, exact: true })?.isExact);
    const newTitle = titles[titleKey];
    if (newTitle !== false) {
      dispatch(pageTitle.actions.change(newTitle || ""));
    }
  }, [pathname, dispatch]);

  return (
    <span className={classes.pageTitle} data-testid="mn_menu_pagetitle">
      <span className="lnr lnr-file-preview"></span>
      <span>
        <Text value={title} />
      </span>
    </span>
  );
}
